"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userFullName = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
/**
 * Gets the user full name
 *
 * @param user - user to get full name of
 * @returns the user full name
 * @public
 */
function userFullName(user) {
    ts_invariant_1.default(user, "user to get full name of must be specified");
    return user.fullName;
}
exports.userFullName = userFullName;
//# sourceMappingURL=index.js.map